/**
 * We can move the types to a separate folder and start maintaining them as
 * ts
 *  |
 *  |__ interfaces
 *     |
 *     |__ xyz.interfaces.ts
 *  |
 *  |__ types
 *    |
 *    |__ Routes.types.ts
 *  |
 *  |__ enums
 *    |
 *    |__ xyz.enums.ts
 *
 * This will help us to maintain the types and interfaces in a better way
 */
export type Pathname = string | string[]

export enum SettingsRoutesEnum {
  GENERAL = '/settings/general',
  BLOCK_PAGES = '/settings/block-pages',
  ENDPOINTS = '/settings/endpoints',
  USERS = '/settings/users',
  AUDIT_LOG = '/settings/audit-log',
  SIEM = '/settings/siem',
  API = '/settings/api',
  BILLING = '/settings/billing',
  GRANT_ACCESS = '/settings/grant-access',
}

export enum PolicyRoutesEnum {
  BASE = '/policies',
  BYPASS = '/policies/bypass',
  CLOUD_APP = '/policies/cloudapp',
  DLP = '/policies/dlp',
  POLICIES_CONTENT = '/policies/content',
  USERS = '/policies/users',
}

export enum EndpointRoutesEnum {
  BASE = '/endpoints',
}

export enum CASBRoutesEnum {
  BASE = '/casb',
  DLP_BASE = '/casb/dlp',
  OVERVIEW = '/casb/dlp/overview',
  FILES = '/casb/dlp/:service/files',
  OVERVIEW_SERVICE = '/casb/dlp/:service/overview',
  GRANT_ACCESS = '/casb/grant-access',
  ACCESS_GRANTED = '/casb/access-granted',
  ACCESS_DENIED = '/casb/access-denied',
  SYNC_FAILURE = '/casb/sync-failure',
}

export enum SSPMRoutesEnum {
  BASE = '/casb/sspm',
  OVERVIEW = '/casb/sspm/:service/overview',
  APPLICATIONS = '/casb/sspm/:service/applications',
}

export enum AnalyticsRoutesEnum {
  ANALYTICS_OVERVIEW = '/analytics/overview',
  ANALYTICS_POLICY = '/analytics/policy',
  ANALYTICS_PRODUCTIVITY = '/analytics/productivity',
  ANALYTICS_SHADOW_IT = '/analytics/shadowit',
  ANALYTICS_AI_USAGE = '/analytics/ai-usage',
  ANALYTICS_AI_USAGE_APPS = '/analytics/ai-usage/apps',
  ANALYTICS_AI_USAGE_USERS = '/analytics/ai-usage/users',
  ANALYTICS_DETAIL = '/analytics/detail',
}

export enum OIDCRouteEnum {
  BASE = '/oidc-welcome',
}
